// import { DefaultSoundsPlayer } from 'classes/voiceovers/DefaultSoundsPlayer'
// import { VoiceOverSoundsPlayer } from 'classes/voiceovers/VoiceOverSoundsPlayer'
// import { IGamePlaySounds } from 'classes/voiceovers/IGamePlaySounds'
// import { getBoardType, isVoiceOverEnabled } from 'screens/gameplay/store/selectors'
// import store from 'store'
// import { isPlayerOnLudoboard } from 'classes/socket/helper'
// import { checkAppState } from 'components/noInternetModal/useFetchAppState'
// import { APP_STATE_ACTIVE } from 'utils/helpers/constants'
// import logger, { TAG_NAMES } from 'utils/Logger'
// import _isEmpty from 'lodash/isEmpty'
// import { BOARD_TYPE } from 'screens/gameplay/types'
import { DefaultSoundsPlayer } from './DefaultSoundsPlayer'
import { VoiceOverSoundsPlayer } from './VoiceOverSoundsPlayer'
import { IGamePlaySounds } from './IGamePlaySounds'
import { isVoiceOverEnabled } from '../../store/selectors/ludoboardSelectors'
import { TWO_PLAYER_CONFIG } from '../../components/GamePlayComponents/constant'
import { store } from '../../store'
import { isPlayerOnLudoboard } from '../socket/helper'
import { APP_STATE_ACTIVE } from '../../utils/helpers/constants'
import { _isEmpty } from '../../utils/helpers/zupeeLodash'

const defaultSoundManager = new DefaultSoundsPlayer()
const voiceOverSoundManager = new VoiceOverSoundsPlayer()

const getSoundManager = (isMyTurn = true): IGamePlaySounds | null => {
  // if (!isPlayerOnLudoboard() || !_isEmpty(checkAppState()) && checkAppState() !== APP_STATE_ACTIVE) {
    if (!isPlayerOnLudoboard()) {

    // logger(TAG_NAMES.LS_GAMEPLAY, 'No Sound Manager for you', {
    //   isBreadcrumb: true,
    //   isLogToFile: true,
    //   data: { isPlayerOnLudoboard: isPlayerOnLudoboard(), checkAppState: checkAppState() }
    // })
    return null
  }
  const boardType = TWO_PLAYER_CONFIG
  return isMyTurn && isVoiceOverEnabled(store.getState()) ? voiceOverSoundManager : defaultSoundManager
}

export const playSkipSound = (skipCount: number, isMyTurn: boolean): void => {
  getSoundManager(isMyTurn)?.playSkipSound(skipCount)
}

export const playTotalTimeSoundOfGame = (): void => {
  getSoundManager()?.playTotalTimeSoundOfGame()
}

export const playStartSoundOfGame = (): void => {
  getSoundManager()?.playStartSoundOfGame()
}

export const playHalfTimeSound = (): void => {
  getSoundManager()?.playHalfTimeSound()
}

export const playLastOneMinutesSound = (): void => {
  getSoundManager()?.playLastOneMinutesSound()
}

export const playExtra56Score = (isMyTurn: boolean): void => {
  getSoundManager(isMyTurn)?.playExtra56Score()
}

//TODO this will be done with FTCP
export const playTokenToHomeSound = (): void => {
  getSoundManager()?.playTokenToHomeSound()
}

export const playZyadaScoreSound = (): void => {
  getSoundManager()?.playZyadaScoreSound()
}

export const playDusrePlayerKaTokenKaatSkteHai = (): void => {
  getSoundManager()?.playDusrePlayerKaTokenKaatSkteHai()
}

export const playTokenKoSafeSpotPrLeJaaSkteHai = (): void => {
  getSoundManager()?.playTokenKoSafeSpotPrLeJaaSkteHai()
}

export const playTokenKoGharLeJaaSkteHai = (): void => {
  getSoundManager()?.playTokenKoGharLeJaaSkteHai()
}
